import  HTTP from "../common/Http";
import { UAParser } from 'ua-parser-js'
import  Utility from "../common/Utility";
// import axios from "axios";
// import regeneratorRuntime from "regenerator-runtime";

/*
export function someAction (context) {
}
*/

const noop = () => {};

export function getWidget({ commit }, payload) {

  const data = {
    wid: payload.wid,
    page_url: getPageUrl(),
    debug: payload.debug,
    v: 1.0
  };

  const url = '/embed/'+payload.wid;

  commit("setLoading", true);

    if (payload.debug == true) {

      }else{

          HTTP.post(url, data)
          .then(function(response) {
            // handle success
              let widget = response.data.embed;
              let website = response.data.website? response.data.website.toLowerCase() : null;
              commit('setWid', widget.wuid)
              commit('setWidStatus', response.data.status)
              commit('setWidWebsite', website)
              commit('setWidgetOptions', widget)

              commit("setLoading", false);
          })
          .catch(function(error) {
            // handle error
            commit("setLoading", false);

          });

     }

}

export function setLanguage({ commit }, lang) {
    commit("setWidgetLanguage", lang)
}


export function getPageUrl(){
    var str = window.location.href;
    var partsOfStr = str.split('?');
    var site = partsOfStr[0];
    return site.replace(/\/?\#?$/, "");
}


export async function logClicks({ commit },payload){

    let __click = 'adabundle__track__clicks__'+Utility.string_to_slug(payload.label);
    let adabundle__track__click = Utility.getCookie(__click);

    if(!adabundle__track__click){

        console.log('Logging click',__click)

        Utility.setCookie(__click, true, 7); //expires in 3 hours

        const ipdata = await ipLookup();

        let parser = new UAParser();
        let ua = parser.getResult();

        let requestData = {
           wid: payload.wid,
           ip: ipdata.data.IPv4,
           url: getPageUrl(),
           preference: ipdata.data,
           operating_system: ua.os.name,
           device: ua.device.name,
           browser: ua.browser.name,
           value: payload.label
        };
        HTTP.post('embed/log/clicks', requestData)
        .then(response => {
            var data = response.data;
        })
        .catch(error => {
        });

     }

}


export async function logViews({ commit },payload){

    let adabundle__track__views = Utility.getCookie('adabundle__track__views');
    let views = adabundle__track__views? adabundle__track__views : 1;

    if(!adabundle__track__views){

        console.log('Logging views',views)

        Utility.setCookie('adabundle__track__views', views, 8); //expires in 4 hours

        const ipdata = await ipLookup();

        let parser = new UAParser();
        let ua = parser.getResult();

        let requestData = {
           wid: payload.wid,
           ip: ipdata.data.IPv4,
           url: getPageUrl(),
           preference: ipdata.data,
           operating_system: ua.os.name,
           device: ua.device.name,
           browser: ua.browser.name,
        };
        HTTP.post('embed/log/views', requestData)
        .then(response => {
            var data = response.data;
        })
        .catch(error => {
        });

    }
}



export async function __logReport({ commit },payload){

    let adabundle__track__reports = Utility.getCookie('adabundle__track__reports');
    let reports = adabundle__track__reports? adabundle__track__reports : 1;

    if(!adabundle__track__reports){

        console.log('Logging report',reports)

        Utility.setCookie('adabundle__track__reports', reports, 14);

        var markup = document.documentElement.outerHTML;

        const ipdata = await ipLookup();

        let requestData = {
           wid: payload.wid,
           html: JSON.stringify(markup),
           ip: ipdata.data.IPv4,
           url: getPageUrl(),
        };
        HTTP.post('embed/log/reports', requestData)
        .then(response => {
            var data = response.data;
        })
        .catch(error => {
        });

    }

}

export const logReport = noop;

export async function ipLookup() {
  try{
    return HTTP.get('https://geolocation-db.com/json/a71be890-9957-11ea-be66-c93168939237');
  }
  catch(e){
    let data = {"country_code":null,"country_name":null,"city":null,"postal":null,"latitude":null,"longitude":null,"IPv4":"127.0.0.1","state":""};
    return data;
  }
}
